module.exports = __webpack_public_path__ + "static/media/Interakt.ad9e6e34.webp";